import { useQuery } from "@tanstack/react-query";
import { getTenant } from "../helpers/tenant";
import { GET_USER_LIST } from "./constants";
import { getUserList } from "../helpers/apis";

const useTenantUsers = () => {
  const tenant = getTenant();
  const { data: users, isLoading: isUsersLoading } = useQuery({
    queryKey: [GET_USER_LIST],
    queryFn: () => getUserList({ company: tenant }),
    gcTime: 300000,
  });
  return { users: users?.users, isUsersLoading };
};

export { useTenantUsers };
